module.exports = __webpack_public_path__ + "img/pdf-3.360f3b0f.jpg";